import LineTagAltIcon from 'LuxKit/Icons/line/LineTagAltIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import FormatPercent from 'components/utils/Formatters/FormatPercent'
import { useContext, useEffect } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import OfferListEventsContext, { OfferListEvents } from 'components/OfferList/OfferListEventsContext'

interface Props {
  /**
   * 0-1
   *
   * @example 0.2 => 20%
   */
  discountPercentage?: number
  /**
   * On mount the message reports a `pricingCalculated` event with no price, standing in for the
   * price stack it usually replaces. Set this when it renders beside a price stack that reports
   * the real price, so the message doesn't overwrite it.
   */
  disablePricingCalculatedEvent?: boolean
}

function SearchTileWalledMessage({ discountPercentage, disablePricingCalculatedEvent = false }: Props) {
  const intl = useIntl()
  const dispatchOfferListEvent = useContext(OfferListEventsContext)

  useEffect(() => {
    if (disablePricingCalculatedEvent) return

    dispatchOfferListEvent({
      type: OfferListEvents.pricingCalculated,
      availability: true,
      price: undefined,
      roomRateId: undefined,
      memberPrice: undefined,
      duration: undefined,
    })
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <BodyTextBlock variant="medium" weight="bold" colour="light-foreground-alt" startIcon={<LineTagAltIcon />}>
    {/* TODO: i18n — contains pricing component (FormatPercent); verify rendered output after localisation */}
    {!!discountPercentage && <FormattedMessage
      id="smDNrmc8FdzV4K5PdNGC"
      defaultMessage="Get {discount} off with member prices"
      description="Member pricing discount message on walled search tile"
      values={{ discount: <FormatPercent value={discountPercentage} /> }}
    />}
    {!discountPercentage && intl.formatMessage({
      id: 'Grey4qftx-iumIzOoqff',
      defaultMessage: 'Log in to see the best price',
      description: 'Sign up prompt on walled search tile when no discount percentage available',
    })}
  </BodyTextBlock>
}

export default SearchTileWalledMessage
